import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class RectifierTirDroite extends ActionCard {
    static typeId = "RECTIFIER_TIR_DROITE";
    static cardName = "Rectifier (Droite)";
    static colorHex = "#FFAA00";
    static countInDeck = ACTION_CARD_COUNTS.RECTIFIER_TIR_DROITE;
    static description = "Déplacez une cible d’une case vers la droite (si cet emplacement n’est pas déjà en joue).";

    isValidOn(slotIndex, gameState) {
        if (slotIndex === 5) return false;
        const hasTargetToken = gameState.lineOfFireSlots[slotIndex];
        const nextTargetHasToken = gameState.lineOfFireSlots[slotIndex + 1];

        // Can't move target to tthe right on last slot && targeted slot has a target token on it
        return hasTargetToken.isTargeted && !nextTargetHasToken.isTargeted;
    }

    resolve(slotIndex, gameState) {
        gameState.adjustShot(slotIndex, "right");
    }
}
